import { useEffect } from "react";

// Type for all possible Ameyo event handler signatures
export type AmeyoEventHandlers = {
  [eventName: string]: (...args: any[]) => void;
};

/**
 * Registers Ameyo event handlers via ameyo.integration.registerCustomFunction.
 * @param handlers - Object mapping event names to handler functions.
 */
export function useAmeyoEvents(handlers: AmeyoEventHandlers) {
  const customIntegration: any = {};
  useEffect(() => {
    if (ameyo?.integration?.registerCustomFunction) {
      for (const [eventName, handler] of Object.entries(handlers)) {
        customIntegration[eventName] = handler;
        ameyo.integration.registerCustomFunction(eventName, customIntegration);
      }
    }
    // Optionally, add cleanup logic if Ameyo provides an unregister API
  }, [handlers,ameyo]);
}